<script setup>
import { onBeforeMount, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import ConsultUsFormDetail from '@/components/consultUsForm/index.vue'

const router = useRouter()
const state = ref('')
const reportName = ref('')
const reportId = ref('')
watch(() => router.currentRoute.value.params.type, (newValue) => {
  console.log(newValue)
  state.value = newValue
})
onBeforeMount(() => {
  state.value = router.currentRoute.value.params.type
},
)
const closeDialog = () => {
  console.log('close')
  if (state.value === 'report') {
    router.push({
      path: '/report/1',
    })
  } else {
    router.push({
      path: '/homePage',
    })
  }
}
</script>

<template>
  <ConsultUsFormDetail :state="state" @close="closeDialog" />
</template>
